import { clsx } from 'clsx';
import { FC } from 'react';
import styles from './SelectOption.css';
import { Checkbox, UIText3 } from '@cian/ui-kit';
import { preventDefault } from 'shared/utils/event';
import { IconFunctionalSuccess16 } from '@cian/ui-kit-design-tokens/icons';
import { TSelectOptionValue } from 'shared/types/filters';

interface ISelectOptionProps {
  value: TSelectOptionValue;
  label: string;
  marker?: string;
  index: number;
  multiple?: boolean;
  selected: boolean;
  onClick(e: React.MouseEvent<HTMLDivElement>): void;
}

export const SelectOption: FC<ISelectOptionProps> = ({ multiple, selected, label, marker, onClick }) => {
  return (
    <div className={clsx(styles['option'], multiple && styles['multiple'])} onClick={onClick}>
      {multiple && (
        <div className={styles['checkbox']}>
          <Checkbox checked={selected} onClick={preventDefault} />
        </div>
      )}

      {!multiple && selected && (
        <div className={styles['icon']}>
          <IconFunctionalSuccess16 color="icon-main-default" />
        </div>
      )}

      {label}

      {marker && (
        <span className={styles['marker']}>
          <UIText3 fontWeight="bold" color="white_100">
            {marker}
          </UIText3>
        </span>
      )}
    </div>
  );
};
